import { atom } from "recoil"
import persistAtom from "./recoilPersist"
import { FieldValues } from "react-hook-form"

interface QuestionnaireFormState {
  [formIndex: number]: {
    eventId: string
    [dataKey: number]: FieldValues
  }
}

export const questionnaireFormState = atom<QuestionnaireFormState>({
  key: "questionnaireFormState",
  default: {},
  effects_UNSTABLE: [persistAtom],
})

export const questionnaireFormIndex = atom<number>({
  key: "questionnaireFormIndex",
  default: 0,
  effects_UNSTABLE: [persistAtom],
})
